module.exports = __webpack_public_path__ + "static/media/503.e3e47e34.png";